import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon, { IconProps, IconWrapper } from "@insite/mobius/Icon";
import Package from "@insite/mobius/Icons/Package";
import Award from "@insite/mobius/Icons/Award";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ClockIcon from "@tsesco/Icons/ClockIcon";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";
import { SECartSupportIcon } from "./SECartSupportIcon";

const enum fields {
    title = "title",
    support = "support",
    iso = "iso",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.support]: string;
        [fields.iso]: string;
    };
}

export interface ProductDetailsSupportStyles {
    titleWrapper?: InjectableCss;
    supportWrapper?: InjectableCss;
    isoWrapper?: InjectableCss;
    typographyText?: InjectableCss;
    mainWrapper?: InjectableCss;
    seProductDetailsSupportSection?: InjectableCss;
}

export const productDetailsSupportStyles: ProductDetailsSupportStyles = {
    titleWrapper: {
        css: css`
            font-family: "Mulish";
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 22px;
            color: ${getColor("text.accent")};
            display: flex;
        `,
    },
    supportWrapper: {
        css: css`
            font-family: "Mulish";
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 22px;
            color: ${getColor("text.accent")};
            display: flex;
        `,
    },
    isoWrapper: {
        css: css`
            font-family: "Mulish";
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 22px;
            color: ${getColor("text.accent")};
            display: flex;
            margin-top: 10px;
        `,
    },
    typographyText: {
        css: css`
            font-size: 14px;
            font-family: "Roboto-bold";
        `,
    },
    mainWrapper: {
        css: css`
            width: 100%;
            background: #EBDFE6;
            /* background: ${getColor("common.border")}; */
            box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            padding: 18px 12px;
            ${TypographyStyle}:last-child {
                margin-bottom: 0px;
            }
            ${TypographyStyle}:first-child {
                margin-bottom: 10px;
            }
        `,
    },
    seProductDetailsSupportSection:
    {
        css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        justify-content: center;
        `
    }
};

const styles = productDetailsSupportStyles;

export const SEProductDetailsSupport: FC<OwnProps> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.seProductDetailsSupportSection}>
        <StyledWrapper {...styles.mainWrapper}>
            <Typography as="p" {...styles.titleWrapper}>
                <Icon src={Package} color="#000" style={{ marginRight: 10 }} />{" "}
                <Typography as="span" {...styles.typographyText}>
                    {fields.title}
                </Typography>
            </Typography>

            <Typography as="p" {...styles.supportWrapper}>
                <Icon src={ClockIcon} color="#000" style={{ marginRight: 10 }} />
                <Typography as="span" {...styles.typographyText}>
                    {fields.support}
                </Typography>
            </Typography>
            {/* <Typography as="p" {...styles.isoWrapper}>
                <Icon src={Award} color="#000" style={{ marginRight: 10 }} />
                <Typography as="span" {...styles.typographyText}>
                    {fields.iso}
                </Typography>
            </Typography> */}
        </StyledWrapper>
        
        <SECartSupportIcon/>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SEProductDetailsSupport,
    definition: {
        group: "Basic",
        displayName: "SE Cart Support",
        fieldDefinitions: [
            {
                name: fields.title,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.support,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.iso,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
